import CommonStyles from 'shared/style/commonPageStyles'
import styled, {css} from 'styled-components'

const Style = {
	Wrapper: CommonStyles.PageWrapper,

	TabDiv: styled.div`
		display: flex;
		gap: 16px;
	`,
	Tab: styled.button`
		${({theme}) => theme.font.small_bold};

		${({$selected}) =>
			$selected &&
			css`
				${({theme}) => theme.font.small_bold};
				color: ${({theme}) => theme.color.major};
			`}
	`,
}

export default Style
